<template>
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.499 13.4989L1.00016 1" stroke="#363636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.499 1L1.00016 13.4989" stroke="#363636" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
